import { Injectable } from '@angular/core';
import {ISystemConfiguration, ISystemConfigurationDetails} from "../interfaces/interfaces";
import {BehaviorSubject, Observable} from "rxjs";
import {SystemConfigurationProxy} from "./system.configuration.proxy";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationService {
  public cachedSysCfg: ISystemConfiguration;

  constructor(private systemConfigurationProxy: SystemConfigurationProxy) {}

  public getConfigByKey(key): ISystemConfigurationDetails {
    return this.cachedSysCfg[key];
  }

  public getSystemConfiguration(): Observable<ISystemConfiguration> {
    return this.systemConfigurationProxy.GetSystemConfiguration().pipe(map(sysCfg => {
      this.cachedSysCfg = sysCfg;
      return sysCfg;
    }));
  }

  public getPreLoginSystemConfiguration(): Observable<ISystemConfiguration> {
    return this.systemConfigurationProxy.GetPreLoginSystemConfiguration().pipe(map(sysCfg => {
      this.cachedSysCfg = sysCfg;
      return sysCfg;
    }));
  }
}
